import { render, staticRenderFns } from "./outpatientData.vue?vue&type=template&id=4406c1f8&scoped=true"
import script from "./outpatientData.vue?vue&type=script&lang=js"
export * from "./outpatientData.vue?vue&type=script&lang=js"
import style0 from "./outpatientData.vue?vue&type=style&index=0&id=4406c1f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4406c1f8",
  null
  
)

export default component.exports